<template>
  <div class="footer_box">
    <div class="top">
      <ul>
        <li>
          <router-link :to="{path: '/about_adjuz'}">关于我们</router-link>
          <p>服务热线： 010-56208704</p>
        </li>
        <li>
          <router-link :to="{path: '/contactus'}">联系我们</router-link>
          <p>服务时间： 周一至周五9:30~18:30</p>
        </li>
        <li>
          <router-link :to="{path: '/joinus'}">加入我们</router-link>
          <p>邮箱： juzhang@adjuz.net</p>
        </li>
      </ul>
    </div>
    <div class="bottom">
      ©2012-2022 asoasa.com 巨掌互动科技（北京）有限公司 </br><span @click="beian">&nbsp;&nbsp;京ICP备：京ICP备16035028号-6&nbsp;&nbsp; </span><span @click="zengzhi">增值电信业务许可证：京B2-20200460</span>
      </br><span @click="toj"><img src="./j.png">&nbsp;京公网安备 11010602007188号</span>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {};
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    beian() {
      window.open("https://beian.miit.gov.cn");
    },
    zengzhi() {
      window.open("https://static.adjuz.com/adjuz-website/ICP证书.jpg");
    },
    toj() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602007188"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.footer_box {
  width: 100%;
  .top {
    background: #111;
    padding: 0.76rem 0 0.86rem 0.72rem;
    li {
      display: flex;
      width: 100%;
      margin-bottom: 0.3rem;
      &:last-child {
        margin-bottom: 0;
      }
      a,
      p {
        font-size: 0.22rem;
        color: #969696;
      }
      a {
        margin-right: 1.48rem;
      }
    }
  }
  .bottom {
    background: #0b0b0b;
    font-size: 0.14rem;
    color: #999999;
    text-align: center;
    padding: 0.28rem 0;
    line-height: 0.4rem;
    border-top: 0.01rem solid #444;
    span {
      font-size: 0.14rem;
    }
    img {
      width: 0.16rem;
      display: inline-block;
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/footer.vue